import { FC } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { Environment } from 'react-relay';
import classNames from 'classnames';
import { PhoneNumberInput } from 'dibs-phone-number-input/exports/PhoneNumber';

import styles from '../../styles/main.scss';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.PhoneNumber.placeholder',
        defaultMessage: 'Phone Number*',
    },
});

type EvenHandler = ({
    name,
    value,
    isValid,
}: {
    name?: string;
    value: string;
    isValid?: boolean;
}) => void;

type Props = {
    value: string;
    error?: string;
    autoFocus?: boolean;
    fieldSize?: 'small' | 'medium' | 'large';
    isBlurred?: boolean;
    disabled?: boolean;
    onChange: EvenHandler;
    onBlur?: EvenHandler;
    onFocus?: EvenHandler;
    isMobile?: boolean;
    countryCode?: string;
    environment: Environment;
};

const PhoneNumber: FC<Props> = ({
    value,
    autoFocus = false,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur,
    onFocus,
    isMobile,
    countryCode,
    environment,
}) => {
    const intl = useIntl();
    const showError = !disabled && isBlurred && !!error;
    const hasValidText = isBlurred && !!value && !showError;
    const placeHolderMessage = intl.formatMessage(messages.placeholder);
    const wrapperClass = classNames({
        [styles.group]: isMobile,
        [styles.left]: !isMobile,
        [styles.mobileWidth]: isMobile,
    });

    return (
        <PhoneNumberInput
            environment={environment}
            countryCode={countryCode}
            name="phoneNumber"
            dataTn="phone-number"
            phoneNumber={value}
            wrapperClass={wrapperClass}
            type="tel"
            placeholder={placeHolderMessage}
            autoFocus={autoFocus}
            size={fieldSize}
            disabled={disabled}
            errorMessage={showError ? error : ''}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            hasValidText={hasValidText}
        />
    );
};

export default PhoneNumber;
